import { sessionStorage } from 'dibs-browser-storage';

import { FAVORITES_SESSION_STORAGE_KEYS } from '../constants';

function setFavoritesNudgeDisplayed(): void {
    sessionStorage.setItem(FAVORITES_SESSION_STORAGE_KEYS.FAVORITES_NUDGE_DISPLAYED, 'true');
}

export { setFavoritesNudgeDisplayed };
